import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TemplatesService } from 'src/app/core/services/templates.service';
import { ObjetoListaPlantillas } from 'src/app/models/ObjetoListaPlantillas';
import * as TiposFacturaEnum from '../../../../shared/enums/tiposFactura.enum';
import { InvoiceService } from '../../../../core/services/invoice.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-listado-pendientes-plantillas',
  templateUrl: './listado-pendientes-plantillas.component.html',
  styleUrls: ['./listado-pendientes-plantillas.component.scss']
})
export class ListadoPendientesPlantillasComponent implements OnInit {

  //Filtro...
  tiposFactura: TiposFacturaEnum.TiposFacturaPLANTILLAS[];
  formulario: FormGroup;
  formularioCompletado: boolean = false;

  //Carga de resultados...
  loading: boolean = false;
  loadingCarga: boolean = false;
  mostrarError: boolean = false;
  cargandoResultados: boolean = false;

  datos: ObjetoListaPlantillas[] = [];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private templatesService: TemplatesService,
    private invoiceServices: InvoiceService,
    private authService: AuthService,
    private router: Router,
  ) {

    this.tiposFactura = TiposFacturaEnum.TiposDeFacturaPLANTILLAEnum;

    this.formulario = this.fb.group({
      tipoDeFactura: [1],
      numeroDocs: [50],
      numeroDocsMax: [100]
    });
  }

  ngOnInit() {
  }

  onSubmit(f: FormGroup) {

    //SE COMPROBARA SI EL INVOICER ESTA EN MANTENIMIENTO.
    //Si es asi, se forzara un cierre de sesion antes de cargar un documento.
    this.authService.ObtenerEstadoMantenimiento().subscribe(enMantenimiento => {

      if (enMantenimiento == true) {
        //Se cierra sesion...

        const userId: string = this.authService.currentUserValue.email;

        this.authService.QuitarDocumentosAsignados(userId).subscribe(quitado => {
          this.authService.Logout();
          this.toastr.info("El Invoicer esta en mantenimiento. Espere un momento a que vuelva a estar habilitado.");
          this.router.navigate(['/Login']);
        }, error => {
          console.log(error);
        });

      } else {

        this.formularioCompletado = false;
        this.cargandoResultados = true;

        console.log("Mostrando datos del formulario: ");
        console.log(f);

        //Carga datos...
        this.loading = true;
        this.mostrarError = false;
        this.datos = [];

        var valueMin = (this.formulario.get('numeroDocs').value) ? this.formulario.get('numeroDocs').value : 0;
        var valueMax = (this.formulario.get('numeroDocsMax').value) ? this.formulario.get('numeroDocsMax').value : 0;

        this.templatesService.ObtenerListadoPlantillasPendientes(
          this.formulario.get('tipoDeFactura').value, valueMin, valueMax)
          .subscribe(datos => {

            var cantidad: number = datos.length;
            var cuenta: number = 0;

            console.log(datos);
            console.log(cantidad);

            if (datos.length == 0) {
              this.loading = false;
              this.cargandoResultados = false;
              this.formularioCompletado = true;
            }

            //comprobamos existencia de prediccionesConfig... Si es así, se les excluye del listado.
            if (this.formulario.get('tipoDeFactura').value == 1) {

              datos.forEach(element => {

                //EMITIDAS
                this.invoiceServices.obtenerNifSecundario(element.secundarioEmitidas)
                  .subscribe((resp: string) => {

                    if (resp == "") {
                      cuenta = cuenta + 1;
                      if (cuenta == cantidad) {
                        this.datos = this.datos.sort(function (a, b) {

                          if (b.fechaUltimoDocProcesado > a.fechaUltimoDocProcesado) { return -1; }
                          if (b.fechaUltimoDocProcesado < a.fechaUltimoDocProcesado) { return 1; }
                          if (b.fechaUltimoDocProcesado == a.fechaUltimoDocProcesado) {

                            if (b.numeroDocs < a.numeroDocs) { return -1; }
                            if (b.numeroDocs > a.numeroDocs) { return 1; }

                            if (b.numeroDocs == a.numeroDocs) {

                              return 0;
                            }
                          }
                        });

                        this.loading = false;
                        this.cargandoResultados = false;
                        this.formularioCompletado = true;
                      }
                      return;
                    }

                    this.templatesService.ComprobarExistePlantillaConfig(1, resp).subscribe(resultado => {

                      if (resultado == false) {
                        this.datos.push(element);
                      }

                      cuenta = cuenta + 1;
                      if (cuenta == cantidad) {

                        this.datos = this.datos.sort(function (a, b) {

                          if (b.fechaUltimoDocProcesado > a.fechaUltimoDocProcesado) { return -1; }
                          if (b.fechaUltimoDocProcesado < a.fechaUltimoDocProcesado) { return 1; }
                          if (b.fechaUltimoDocProcesado == a.fechaUltimoDocProcesado) {

                            if (b.numeroDocs < a.numeroDocs) { return -1; }
                            if (b.numeroDocs > a.numeroDocs) { return 1; }

                            if (b.numeroDocs == a.numeroDocs) {

                              return 0;
                            }
                          }
                        });

                        this.loading = false;
                        this.cargandoResultados = false;
                        this.formularioCompletado = true;
                      }

                    }, error => {
                      console.log(error);
                    });
                  }, error => {
                    console.log(error);
                  });
              });
            }

            if (this.formulario.get('tipoDeFactura').value == 2) {

              datos.forEach(element => {

                this.templatesService.ComprobarExistePlantillaConfig(2, element.cifRecibidas).subscribe(resultado => {

                  if (resultado == false) {
                    this.datos.push(element);
                  }

                  cuenta = cuenta + 1;
                  if (cuenta == cantidad) {

                    this.datos = this.datos.sort(function (a, b) {

                      if (b.fechaUltimoDocProcesado > a.fechaUltimoDocProcesado) { return -1; }
                      if (b.fechaUltimoDocProcesado < a.fechaUltimoDocProcesado) { return 1; }
                      if (b.fechaUltimoDocProcesado == a.fechaUltimoDocProcesado) {

                        if (b.numeroDocs < a.numeroDocs) { return -1; }
                        if (b.numeroDocs > a.numeroDocs) { return 1; }

                        if (b.numeroDocs == a.numeroDocs) {

                          return 0;
                        }
                      }
                    });

                    this.loading = false;
                    this.cargandoResultados = false;
                    this.formularioCompletado = true;
                  }

                }, error => {
                  console.log(error);
                });
              });
            }

          }, (error) => {
            console.log(error);
            this.loading = false;
            this.mostrarError = true;
          });
      }

    }, error => {
      console.log(error);
    });
  }

  GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  convertDateToString(number) {
    if (isNaN(number) === false) {
      if (number > 0) {
        number = number.toString().substring(6, 8) + '/' + number.toString().substring(4, 6) +
          '/' + number.toString().substring(0, 4);
        return number;
      }
    }
    return '';
  }

  hacerPlantilla(elemento: ObjetoListaPlantillas) {

    var tipo: number = this.formulario.get('tipoDeFactura').value;

    var cadena: string = (tipo == 1) ? elemento.secundarioEmitidas : elemento.cifRecibidas;

    var quieroPlantilla: any = {
      nifSecundario: cadena,
      tipo: tipo
    };

    this.router.navigate(['/Templates/', quieroPlantilla]);
  }

}
